import {Localizer} from "../../../infrastructure/localization/localizer";

export enum DashboardKompetenceGodkendtPercentageEnum {
    NulProcent = 1,
    EnTilFemogtyveProcent = 2,
    SeksogtyveTilHalvtredsProcent = 3,
    EnoghalvtredsTilSeksoghalvfjerdsProcent = 4,
    SeksoghalvfjerdsTilNiOgHalvfemsProcent = 5,
    HundredeProcent = 6
}

export class KompetenceGodkendtCounts {
    kompetenceGroupCategory: DashboardKompetenceGodkendtPercentageEnum;
    kompetenceGroupCategoryName: string;
    count: number;
    onCellClick: () => void;
}

export const translateDashboardKompetenceGodkendtPercentageEnum = (value: DashboardKompetenceGodkendtPercentageEnum): string => {
    switch (value) {
        case DashboardKompetenceGodkendtPercentageEnum.NulProcent:
            return Localizer.dashboard_nulProcent();
        case DashboardKompetenceGodkendtPercentageEnum.EnTilFemogtyveProcent:
            return Localizer.dashboard_enTilFemogtyveProcent();
        case DashboardKompetenceGodkendtPercentageEnum.SeksogtyveTilHalvtredsProcent:
            return Localizer.dashboard_seksogtyveTilHalvtredsProcent();
        case DashboardKompetenceGodkendtPercentageEnum.EnoghalvtredsTilSeksoghalvfjerdsProcent:
            return Localizer.dashboard_enoghalvtredsTilFemoghalvfjerdsProcent();
        case DashboardKompetenceGodkendtPercentageEnum.SeksoghalvfjerdsTilNiOgHalvfemsProcent:
            return Localizer.dashboard_seksoghalvfjerdsTilNioghalvfemsProcent();
        case DashboardKompetenceGodkendtPercentageEnum.HundredeProcent:
            return Localizer.dashboard_hundredeProcent();
        default:
            return "Unknown";
    }
}
export const getMinMaxValue = (value: DashboardKompetenceGodkendtPercentageEnum): [number, number] => {
    switch (value) {
        case DashboardKompetenceGodkendtPercentageEnum.NulProcent:
            return [0, 0];
        case DashboardKompetenceGodkendtPercentageEnum.EnTilFemogtyveProcent:
            return [1, 25];
        case DashboardKompetenceGodkendtPercentageEnum.SeksogtyveTilHalvtredsProcent:
            return [26, 50];
        case DashboardKompetenceGodkendtPercentageEnum.EnoghalvtredsTilSeksoghalvfjerdsProcent:
            return [51, 75];
        case DashboardKompetenceGodkendtPercentageEnum.SeksoghalvfjerdsTilNiOgHalvfemsProcent:
            return [76, 99];
        case DashboardKompetenceGodkendtPercentageEnum.HundredeProcent:
            return [100, 100];
        default:
            return [0, 100];
    }
}

export const enumIndexMap = {
    [DashboardKompetenceGodkendtPercentageEnum.NulProcent]: 0,
    [DashboardKompetenceGodkendtPercentageEnum.EnTilFemogtyveProcent]: 1,
    [DashboardKompetenceGodkendtPercentageEnum.SeksogtyveTilHalvtredsProcent]: 2,
    [DashboardKompetenceGodkendtPercentageEnum.EnoghalvtredsTilSeksoghalvfjerdsProcent]: 3,
    [DashboardKompetenceGodkendtPercentageEnum.SeksoghalvfjerdsTilNiOgHalvfemsProcent]: 4,
    [DashboardKompetenceGodkendtPercentageEnum.HundredeProcent]: 5
};
